import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './Main';
import Login from './components/Login';
import Register from './components/Register';
import AuthMiddleware from './middleware/AuthMiddleware';

function App() {
    return (
        <BrowserRouter>
           <AuthMiddleware>
                <Routes>
                    <Route path="/dashboard" element={<Main />} />
                    <Route path="/" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                </Routes>
           </AuthMiddleware>
        </BrowserRouter>
    );
}

export default App;